import { Complaint } from '../Complaint'
import { formatYesNoToTrueFalse, saveComplaint } from '../../utilities'
import { formSchema } from './schema'
import { fraudWasteAbuse } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class FraudWasteAbuseComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'fraud_waste_abuse'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.fraudwasteabuse.confirmation
  }

  /*
   * Combine the FWA unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const {
      allegation,
      allegation_other,
      business_unit,
      employee_type,
      employee_type_other,
      hhs_program_detail,
      office_of_secretary,
      retaliated_against
    } = formData

    // Convert 'Yes' 'No' to 'True' 'False' for the API data.
    const was_retaliated_against = formatYesNoToTrueFalse(retaliated_against)

    const detail = {
      allegation,
      allegation_other,
      business_unit,
      employee_type,
      employee_type_other,
      hhs_program_detail,
      office_of_secretary,
      retaliated_against: was_retaliated_against
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }

  /*
   * Convert the form data to a complaint object.
   * Call the parent method to save the complaint by posting to the API.
   * Append retaliated_against to the confirmation URL.
   * Is called when user clicks submit button.
   */
  saveFormData(formData) {
    const complaint = this.formatComplaintForRequest(formData)
    const successURL =
      routes.fraudwasteabuse.confirmation +
      '/?retaliated-against=' +
      complaint.detail.retaliated_against

    saveComplaint(complaint, this.props.history, successURL)
  }
}

export default withRecaptcha(
  withBackButtonProtection(
    withDocTitle(FraudWasteAbuseComplaint, fraudWasteAbuse)
  )
)
